export const REPORTING_PORTAL_URL =
  "https://app.light-truth.com/report/4/the-records-hub-external-providers";
